import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import { colors } from "./icons-styles";

export const iconVariants = cva("", {
  variants: {
    size: {
      lg: "size-xl",
      md: "size-lg",
      sm: "size-md",
      xs: "size-sm",
      custom: "",
    },
    variant: {
      thin: "stroke-1",
      thick: "stroke-2",
      strong: "stroke-[3px]",
      filled: "",
    },
    color: colors,
  },
  compoundVariants: [
    {
      variant: "filled",
      className: "stroke-2",
    },
  ],
  defaultVariants: {
    color: "black",
    size: "md",
    variant: "thick",
  },
});

export interface IIconProps {
  className?: string;
  height?: string | number;
  width?: string | number;
  title?: string;
  testId?: string;
  onClick?: (event: Event) => void;
}

export interface IIconInterface
  extends IIconProps,
    VariantProps<typeof iconVariants> {}
